<template>
  <div class="education" v-if="model">
    <div class="logo">
      <a :href="model.data.url"
         target="_blank"><div class="image"
                              :style="{ backgroundImage }"></div></a>
    </div>
    <div>
      <div class="degree">{{ model.data.degree }} in {{ model.data.major }}</div>
      <div class="school"><a :href="model.data.url" target="_blank">{{ model.data.school }}</a></div>
    </div>
    <div>
      <div class="date">{{ model.getDateString() }}</div>
      <div class="location">{{ model.data.location }}</div>
    </div>
  </div>
</template>

<script>

export default {
    name  : "Education",
    props : {
        model : {
            type : Object
        }
    },
    computed : {
        backgroundImage() {
            return `url(/images/edu-logos/light/${this.model.data.logo_file})`;
        }
    }
};

</script>

<style scoped>

.education {
    display:flex;
    justify-content:space-between;
    align-items:flex-end;
    color:var(--core-white);
    background-image:-webkit-linear-gradient(to right, rgba(var(--main-gray-rgb), 0.5), rgba(var(--main-gray-rgb), 0.1));
    background-image:-moz-linear-gradient(to right, rgba(var(--main-gray-rgb), 0.5), rgba(var(--main-gray-rgb), 0.1));
    background-image:-ms-linear-gradient(to right, rgba(var(--main-gray-rgb), 0.5), rgba(var(--main-gray-rgb), 0.1));
    background-image:linear-gradient(to right, rgba(var(--main-gray-rgb), 0.5), rgba(var(--main-gray-rgb), 0.1));
    padding:20px;
    margin-top:20px;
    position:relative;
}

.education:before {
    content:"";
    position:absolute;
    z-index:-1;
    top:0px;
    left:0px;
    width:100%;
    height:100%;
    box-shadow:0px 0px 15px 5px var(--white-orange);
    opacity:0;
    transition:opacity 3000ms;
}

.education:hover:before {
    opacity:1;
    transition:opacity 500ms;
}

.logo {
    transform:scale(1);
    transition:transform 350ms;
}

.logo:hover {
    transform:scale(1.1);
}

.image {
    width:60px;
    height:60px;
    background-size:contain;
    background-repeat:no-repeat;
    background-position:center;
}

.degree, .school, .date, .location {
    text-align:right;
    font-size:20px;
}

.date, .location {
    text-align:left;
    font-weight:bold;
}

.school a {
    color:inherit;
}

</style>
